import React, {useContext, useMemo, useRef, useState} from 'react';
import {Form} from '@unform/web';
import qs from 'qs';
import Yup from '../../../infra/Yup';
import {ThemeContext} from '../../../apiContexts';
import {buildReportQuery, getMemorizeReportForm, memorizeReportForm, reportExportFormat, reportFileBaseName, saveReportFile} from '../../../helpers/report';
import {externalReport} from '../../../services/reportService';
import {useIntl} from 'react-intl';
import DeviceGroupSelect from './deviceGroupSelect';
import FooterActions from './footerActions';
import {noPeriodReportValidation} from './validation';

const schema = noPeriodReportValidation(Yup);

const CertadocFineConfig = (props) => {
    const {
        devices,
        redirectToReport,
        groups,
        notifyToast,
    } = props;

    const formRef = useRef(null);
    const intl = useIntl();
    const theme = useContext(ThemeContext);

    // The report is a snapshot of the fines that exist right now, so it has no period.
    const initialData = useMemo(() => getMemorizeReportForm('device', 'group'), []);

    const [outer, setOuter] = useState();
    const [loading, setLoading] = useState();

    const toReport = async (data) => {
        try {
            await schema.validate(data, {
                abortEarly: false,
                recursive: true,
            });

            const params = {};

            if (data.device) {
                params.deviceId = data.device.map(Number);
            }

            if (data.group) {
                params.groupId = Number(data.group);
            }

            memorizeReportForm({...data});

            if (outer) {
                try {
                    const format = reportExportFormat(outer);
                    params.mail = outer === 'mail';
                    setLoading(true);

                    const response = await externalReport(
                        'certadocfines',
                        qs.stringify(params, {indices: false}),
                        !params.mail,
                        format,
                    );

                    if (response) {
                        saveReportFile(response, format, reportFileBaseName({
                            intl, titleId: 'reportCertadocFines', devices,
                            deviceIds: data.device,
                        }));
                    }
                    setLoading(false);
                    params.mail && notifyToast('success');
                } catch (err) {
                    notifyToast('error', err);
                    setLoading(false);
                }
                setOuter(null);
                return;
            }

            redirectToReport(`certadocfines?${buildReportQuery(params)}`);
        } catch (err) {
            const validationErrors = {};
            if (err instanceof Yup.ValidationError) {
                err.inner.forEach((error) => {
                    validationErrors[error.path] = error.message;
                });
                formRef.current.setErrors(validationErrors);
            } else {
                notifyToast('error', err);
                setLoading(false);
            }
        }
    };

    return (
        <div>
            {devices && groups && (
                <Form ref={formRef} schema={schema} initialData={initialData} onSubmit={toReport}>
                    <DeviceGroupSelect {...{devices, groups, initialData}} />

                    <FooterActions theme={theme} setOuter={setOuter} loading={loading} />
                </Form>
            )}
        </div>
    );
};

export default CertadocFineConfig;
